export class FetchDesignSpecification {
  static readonly type = '[Print] Fetch Design Spec';

  constructor(public decoDesignId: number) {}
}
